var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedulesactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#414141;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Schedules_active",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.2,44.7H4.9c-3,0-5.4-2.4-5.4-5.4V12.2c0-3,2.4-5.4,5.4-5.4h25.3c3,0,5.4,2.4,5.4,5.4V23 c0,0.9-0.7,1.7-1.7,1.8c-4.2,0.4-7.4,3.9-7.4,8.1c0,3.6,2.4,6.8,5.8,7.8c0.7,0.2,1.2,0.8,1.3,1.6c0.1,0.7-0.3,1.4-1,1.8 C32,44.5,31.1,44.7,30.2,44.7z M4.9,10.4c-1,0-1.8,0.8-1.8,1.8v27.1c0,1,0.8,1.8,1.8,1.8h21.3c-2-2.1-3.3-5-3.3-8.1 c0-5.5,3.8-10.2,9-11.4v-9.3c0-1-0.8-1.8-1.8-1.8H4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.6,12.5c-1,0-1.8-0.8-1.8-1.8V3.1c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8v7.6C11.4,11.7,10.6,12.5,9.6,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.3,12.5c-1,0-1.8-0.8-1.8-1.8V3.1c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8v7.6C28.1,11.7,27.3,12.5,26.3,12.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.7,19.7H2.3c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8h31.4c1,0,1.8,0.8,1.8,1.8 C35.5,18.9,34.7,19.7,33.7,19.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_665_00000081627244923633159310000016278856124895579562_",
    className: "st0",
    cx: 34.7,
    cy: 32.9,
    r: 9.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.7,44.7c-6.5,0-11.7-5.3-11.7-11.7s5.3-11.7,11.7-11.7s11.7,5.3,11.7,11.7S41.2,44.7,34.7,44.7z  M34.7,24.8c-4.5,0-8.1,3.6-8.1,8.1s3.6,8.1,8.1,8.1s8.1-3.6,8.1-8.1S39.2,24.8,34.7,24.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.9,34.8h-2.1c-1,0-1.8-0.8-1.8-1.8v-4.1c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8v2.3h0.3 c1,0,1.8,0.8,1.8,1.8C38.7,34,37.9,34.8,36.9,34.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulesactive);
export default __webpack_public_path__ + "static/media/Schedules active.d3ff9bb41de19007d95187af05826c15.svg";
export { ForwardRef as ReactComponent };